import { useEffect, useState } from "react";

// Component and CSS map
const componentMap = {
    "General_Temp": {
        component: () => import("./GeneralWidget"),
        cssFile: `${process.env.PUBLIC_URL}/whats-app/temp-css/GeneralWidget.css`, 
    },
    "Message_Field_Temp": {
        component: () => import("./MessageFieldWidget"),
        cssFile: `${process.env.PUBLIC_URL}/whats-app/temp-css/MessageFieldWidget.css`, 
    },
    "White_Theme_Temp": {
        component: () => import("./WhiteThemeWidget"),
        cssFile: `${process.env.PUBLIC_URL}/whats-app/temp-css/WhiteThemeWidget.css`, 
    },
    "Light_Theme_Temp": {
        component: () => import("./LightThemeWidget"),
        cssFile: `${process.env.PUBLIC_URL}/whats-app/temp-css/LightThemeWidget.css`, 
    },
    "Dark_Theme_Temp": {
        component: () => import("./DarkThemeWidget"),
        cssFile: `${process.env.PUBLIC_URL}/whats-app/temp-css/DarkThemeWidget.css`, 
    },
    "Booking_Temp": {
        component: () => import("./BookingWidget"),
        cssFile: `${process.env.PUBLIC_URL}/whats-app/temp-css/BookingWidget.css`, 
    },
}; 

const DynamicTemplate = ({ selectedTemplate, isTemplateId, widgetId, selectedLayout, updateWhatsAppTabData, whatsAppTabData }) => {
    const [TemplateComponent, setTemplateComponent] = useState(null);

    useEffect(() => {
        const loadTemplate = async () => {
            const template = componentMap[selectedTemplate];
            if (!template) {
                setTemplateComponent(null);
                return;
            }

            // Remove all previously injected dynamic CSS
            const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
            oldLinks.forEach(link => link.remove());

            // Inject new CSS
            if (template.cssFile) {
                const link = document.createElement("link");
                link.rel = "stylesheet";
                link.href = template.cssFile;
                if (widgetId) {
                    link.setAttribute("wtsapp-chat-data-dynamic-css", selectedTemplate);
                } else {
                    link.setAttribute("data-dynamic-css", selectedTemplate);
                }
                document.head.appendChild(link);
            }

            // Load component
            const componentModule = await template.component();
            setTemplateComponent(() => componentModule.default);
        };

        loadTemplate();
    }, [selectedTemplate,widgetId]);

    if (!TemplateComponent)
        return (
            <div className="loader-container">
                <div className="spinner"></div>
                <p>Loading please wait...</p>
            </div>
        );

    return (
        <TemplateComponent selectedTemplate={selectedTemplate} selectedLayout={selectedLayout} isTemplateId={isTemplateId} widgetId={widgetId} updateWhatsAppTabData={updateWhatsAppTabData} whatsAppTabData={whatsAppTabData}
        /> 
    );
};

export default DynamicTemplate;
